"use client";

import { Bug } from "lucide-react";
import { useTranslations } from "next-intl";
import dynamic from "next/dynamic";
import { useEffect, useState } from "react";

import { testerApi, type TesterStatus } from "@/shared/api/tester";
import { Button } from "@/shared/ui/buttons/button";

// KAN-975: модалка с формами на zod — отдельным чанком. В проде кнопка не показывается,
// а статический import затаскивал zod и схемы в общую оболочку обоих лейаутов.
const BugReportModal = dynamic(() => import("./bug-report-modal"), { ssr: false });

export function BugReportButton() {
  const tUi = useTranslations("Ui");
  const [isOpen, setIsOpen] = useState(false);
  const [testerStatus, setTesterStatus] = useState<TesterStatus | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkTesterStatus = async () => {
      try {
        const status = await testerApi.getStatus();
        setTesterStatus(status);
      } catch (_error) {
        // Не тестер или не авторизован
        setTesterStatus({ isTester: false });
      } finally {
        setIsLoading(false);
      }
    };

    // Проверяем только в dev режиме
    if (process.env.NODE_ENV === "development") {
      checkTesterStatus();
    } else {
      setIsLoading(false);
    }
  }, []);

  // Не показываем в продакшене или если не тестер
  if (
    process.env.NODE_ENV !== "development" ||
    isLoading ||
    !testerStatus?.isTester
  ) {
    return null;
  }

  return (
    <>
      <div className="fixed bottom-4 right-4 z-50">
        <Button
          onClick={() => setIsOpen(true)}
          className="bg-red-600 hover:bg-red-700 text-white shadow-lg"
          size="lg"
        >
          <Bug className="mr-2 h-5 w-5" />
          {tUi("bugReportButton.soobschitOProbleme")}
        </Button>
      </div>

      <BugReportModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
